export default "__VITE_ASSET__DzMObBh___"